'use strict'

jQuery(document).ready(function($) {
	console.log('JTF Child Theme Main Script Loaded');

	// Change placeholder in the search bar.
	$( 'input[name=s]' ).attr( 'placeholder', 'Enter search terms' );

	// Decrease the size of the message textbox in the footer.
	$( '#input_1_6' ).attr( 'rows', '6' );

	// Identify every iframe that is a Youtube embed
	$( "iframe[src*='youtube']" ).each ( function() {
		$( this ).attr( 'data-youtube', 1 );
	} );

});

window.onload = function() {
	if ( navigator.appVersion.indexOf('MSIE') != -1 ) {
		console.log(navigator.appVersion.indexOf('MSIE'));
		console.log('This is IE so show banner');
		document.getElementById("ie-banner").style.display = "block";
	}
}
